'use client'

import { useTranslations } from 'next-intl'
import { useRouter } from 'next/navigation'
import { useEffect } from 'react'

import type { DialogConfirmResolve } from '@/components/addons/dialog/dialog.type'
import { useDialog } from '@/hooks'

interface ExpirationPopupProps {
  isExpired: boolean
  promotionTitle?: string
}

export default function ExpirationPopup({ isExpired, promotionTitle }: ExpirationPopupProps) {
  const t = useTranslations()
  const dialog = useDialog()
  const router = useRouter()

  useEffect(() => {
    if (isExpired) {
      // Show expiration confirm popup with navigation option
      dialog
        .confirm(
          <div className='expiration-popup-content'>
            <div className='expiration-icon'>
              <svg
                className='mx-auto h-16 w-16 text-theme-orange'
                fill='none'
                stroke='currentColor'
                viewBox='0 0 24 24'
                xmlns='http://www.w3.org/2000/svg'>
                <path
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  strokeWidth={2}
                  d='M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
                />
              </svg>
            </div>
            <div className='expiration-content'>
              <h3 className='expiration-title'>
                {promotionTitle
                  ? t('Promotion Detail.promotion_expired_with_title', { title: promotionTitle })
                  : t('Promotion Detail.promotion_expired')}
              </h3>
              <p className='expiration-description'>
                {t('Promotion Detail.promotion_expired_description')}
              </p>
            </div>
          </div>,
          {
            title: t('Promotion Detail.promotion_expired_title'),
            btnConfirm: t('Promotion Detail.view_other_promotions') || 'View Promotions',
            hideCancelButton: true,
            allowEscape: false,
            allowClickOutside: false
          }
        )
        .then((result) => {
          const confirmResult = result as DialogConfirmResolve
          if (confirmResult.isConfirmed) {
            router.push('/promotion/')
          }
        })
    }
  }, [isExpired, promotionTitle, dialog, router, t])

  return null // This component doesn't render anything visible
}
